/* FanNest storefront JS — extracted from sections/anime-store.liquid.
   Loaded via the asset_url filter in that section's bridge tags.
   The one Liquid value (promo fallback) is injected as window.PROMO_TEXT_FALLBACK. */
const GIPHY_KEY = 'dnhsKxU33nFkfL7AUczHyEUzdnk8F9uD';
const STORE_URL = 'https://anime-lovers-9830.myshopify.com';
let products = [];

// ── CURRENCY (multi-region, base = AUD, user can switch via dropdown) ──
const BASE_CURRENCY = 'AUD';
const CURRENCY_META = {
  AUD:{s:'A$',n:'Australian Dollar'}, USD:{s:'US$',n:'US Dollar'}, EUR:{s:'€',n:'Euro'}, GBP:{s:'£',n:'British Pound'},
  CAD:{s:'C$',n:'Canadian Dollar'}, NZD:{s:'NZ$',n:'NZ Dollar'}, JPY:{s:'¥',n:'Japanese Yen'}, CNY:{s:'¥',n:'Chinese Yuan'},
  KRW:{s:'₩',n:'Korean Won'}, INR:{s:'₹',n:'Indian Rupee'}, IDR:{s:'Rp ',n:'Indonesian Rupiah'}, MYR:{s:'RM ',n:'Malaysian Ringgit'},
  SGD:{s:'S$',n:'Singapore Dollar'}, THB:{s:'฿',n:'Thai Baht'}, PHP:{s:'₱',n:'Philippine Peso'}, VND:{s:'₫',n:'Vietnamese Dong'},
  TWD:{s:'NT$',n:'Taiwan Dollar'}, HKD:{s:'HK$',n:'Hong Kong Dollar'}, BRL:{s:'R$',n:'Brazilian Real'}, MXN:{s:'MX$',n:'Mexican Peso'},
  ARS:{s:'AR$',n:'Argentine Peso'}, CLP:{s:'CL$',n:'Chilean Peso'}, COP:{s:'CO$',n:'Colombian Peso'}, ZAR:{s:'R ',n:'South African Rand'},
  NGN:{s:'₦',n:'Nigerian Naira'}, EGP:{s:'E£',n:'Egyptian Pound'}, KES:{s:'KSh ',n:'Kenyan Shilling'}, AED:{s:'AED ',n:'UAE Dirham'},
  SAR:{s:'SAR ',n:'Saudi Riyal'}, ILS:{s:'₪',n:'Israeli Shekel'}, TRY:{s:'₺',n:'Turkish Lira'}, PKR:{s:'₨',n:'Pakistani Rupee'},
  BDT:{s:'৳',n:'Bangladeshi Taka'}, LKR:{s:'Rs ',n:'Sri Lankan Rupee'}, CHF:{s:'CHF ',n:'Swiss Franc'}, SEK:{s:'kr ',n:'Swedish Krona'},
  NOK:{s:'kr ',n:'Norwegian Krone'}, DKK:{s:'kr ',n:'Danish Krone'}, PLN:{s:'zł ',n:'Polish Zloty'}, CZK:{s:'Kč ',n:'Czech Koruna'},
  HUF:{s:'Ft ',n:'Hungarian Forint'}, RON:{s:'lei ',n:'Romanian Leu'}, RUB:{s:'₽',n:'Russian Ruble'}, UAH:{s:'₴',n:'Ukrainian Hryvnia'}
};
const ZERO_DEC = new Set(['JPY','KRW','VND','IDR','CLP','UGX','RWF','XAF','XOF']);
let userCurrency = { code: BASE_CURRENCY, symbol: CURRENCY_META[BASE_CURRENCY].s, rate: 1 };
let fxRates = { [BASE_CURRENCY]: 1 };

async function fetchFxRates() {
  try {
    const fx = await fetch(`https://open.er-api.com/v6/latest/${BASE_CURRENCY}`).then(r => r.json());
    if (fx.rates) fxRates = fx.rates;
  } catch(e) {}
}
function setCurrency(code, persist = true) {
  if (!CURRENCY_META[code] || !fxRates[code]) return;
  userCurrency = { code, symbol: CURRENCY_META[code].s, rate: fxRates[code] };
  if (persist) try { localStorage.setItem('fannest_currency', code); } catch(e) {}
  const sel = document.getElementById('currency-select');
  if (sel) sel.value = code;
  if (typeof renderProducts === 'function' && products.length) renderProducts(typeof activeCategory !== 'undefined' ? activeCategory : 'all');
  if (typeof updateCartUI === 'function') updateCartUI();
  if (typeof modalProduct !== 'undefined' && modalProduct) {
    const mp = document.getElementById('modal-price');
    if (mp) {
      const vid = modalProduct._selectedVariantId || modalProduct.variantId;
      const v = modalProduct.variants.find(x => x.id === vid) || modalProduct.variants[0];
      mp.textContent = formatPrice(v.price);
    }
  }
}
async function initCurrency() {
  await fetchFxRates();
  let chosen = null;
  try { chosen = localStorage.getItem('fannest_currency'); } catch(e) {}
  if (!chosen) {
    try {
      const geo = await fetch('https://ipapi.co/json/').then(r => r.json());
      if (geo.currency && CURRENCY_META[geo.currency] && fxRates[geo.currency]) chosen = geo.currency;
    } catch(e) {}
  }
  if (!chosen) chosen = BASE_CURRENCY;
  populateCurrencyDropdown();
  setCurrency(chosen, false);
}
function populateCurrencyDropdown() {
  const sel = document.getElementById('currency-select');
  if (!sel) return;
  const codes = Object.keys(CURRENCY_META).filter(c => fxRates[c]).sort();
  sel.innerHTML = codes.map(c => `<option value="${c}">${c} · ${CURRENCY_META[c].s.trim()}</option>`).join('');
  sel.onchange = (e) => setCurrency(e.target.value);
}
function formatPrice(base) {
  const val = base * userCurrency.rate;
  const out = ZERO_DEC.has(userCurrency.code) ? Math.round(val).toLocaleString() : val.toFixed(2);
  return userCurrency.symbol + out;
}

function detectCategory(p) {
  const text = (p.title + ' ' + p.handle + ' ' + (p.tags || []).join(' ')).toLowerCase();
  if (text.includes('sticker')) return 'stickers';
  if (text.includes('keychain') || text.includes('charm') || text.includes('key tag') || text.includes('key ring')) return 'keychains';
  return 'figures';
}

// Short, clear product names: "{Series} {Type}" e.g. "My Hero Academia Figure"
const SERIES_DISPLAY = { rezero:'Re:Zero', mha:'My Hero Academia', demonslayer:'Demon Slayer', onepiece:'One Piece', ghibli:'Studio Ghibli', wistoria:'Wistoria', naruto:'Naruto', attackontitan:'Attack on Titan', jjk:'Jujutsu Kaisen', dragonball:'Dragon Ball', bleach:'Bleach', mushokutensei:'Mushoku Tensei', bluelock:'Blue Lock', chainsawman:'Chainsaw Man', sololeveling:'Solo Leveling', vinlandsaga:'Vinland Saga', hxh:'Hunter x Hunter', fairytail:'Fairy Tail', sao:'Sword Art Online', fullmetal:'Fullmetal Alchemist', deathnote:'Death Note', tokyoghoul:'Tokyo Ghoul', blackclover:'Black Clover', haikyuu:'Haikyuu!!', toaru:'Frieren', tensura:'Slime', overlord:'Overlord', konosuba:'KonoSuba', codegeass:'Code Geass', evangelion:'Evangelion', general:'Anime' };
const TYPE_LABEL = { figures:'Figure', keychains:'Keychain', stickers:'Sticker' };
function cleanProductTitle(rawTitle, handle) {
  const cat = detectCategory({ title: rawTitle, handle: handle, tags: [] });
  const series = getAnimeSeries({ handle: handle, fullTitle: rawTitle });
  return (SERIES_DISPLAY[series] || 'Anime') + ' ' + (TYPE_LABEL[cat] || 'Collectible');
}

async function loadProducts() {
  const grid = document.getElementById('products-grid');
  grid.innerHTML = '<div style="grid-column:1/-1;text-align:center;padding:60px;color:var(--ocean-foam);font-size:18px;font-weight:700">🌊 Loading products...</div>';
  await initCurrency();
  try {
    // country=AU pins prices to the shop's AUD base — otherwise Shopify Markets serves
    // localized (IDR/USD) prices to overseas visitors and our converter double-counts them.
    const data = await fetch(`${STORE_URL}/products.json?limit=250&page=1&country=AU`).then(r => r.json());
    const raw = data.products || [];
    products = raw.map((p, i) => mapRawProduct(p, i));
    productPage = 1;
    moreProducts = raw.length === 250;   // a full page means more may exist → arm infinite scroll
    renderProducts('all');
    updateCartUI();
    setupInfiniteScroll();
  } catch(e) {
    grid.innerHTML = '<div style="grid-column:1/-1;text-align:center;padding:60px;color:var(--ocean-foam)">⚠️ Failed to load products. Please refresh the page.</div>';
  }
}

// Map one raw Shopify product to our lightweight card model. `i` = absolute index (drives new/hot badges).
function mapRawProduct(p, i) {
  return {
    id: p.id,
    title: cleanProductTitle(p.title, p.handle),
    fullTitle: p.title,
    price: parseFloat(p.variants[0].price),
    category: detectCategory(p),
    badge: i < 2 ? 'new' : (i < 5 ? 'hot' : ''),
    variantId: p.variants[0].id,
    handle: p.handle,
    img: p.images[0]?.src || '',
    images: p.images.map(img => img.src),
    bodyHtml: p.body_html || '',
    variants: p.variants.map(v => ({
      id: v.id,
      title: v.title,
      price: parseFloat(v.price),
      available: v.available !== false,
      inventory_quantity: v.inventory_quantity ?? null,
      img: v.featured_image?.src || null
    }))
  };
}

// ── Infinite scroll: pull the next 250 when the shopper nears the bottom ──
let productPage = 1;
let moreProducts = false;
let loadingMore = false;
async function loadMoreProducts() {
  if (loadingMore || !moreProducts) return;
  loadingMore = true;
  try {
    const nextPage = productPage + 1;
    const data = await fetch(`${STORE_URL}/products.json?limit=250&page=${nextPage}&country=AU`).then(r => r.json());
    const raw = data.products || [];
    const grid = document.getElementById('products-grid');
    const offset = products.length;
    raw.forEach((rp, j) => {
      const p = mapRawProduct(rp, offset + j);
      products.push(p);
      const show = activeCategory === 'all' || p.category === activeCategory;
      grid.appendChild(createProductCard(p, show));
    });
    productPage = nextPage;
    moreProducts = raw.length === 250;   // short page = no more pages
    applyProductBatch();
  } catch(e) {}
  loadingMore = false;
}
function setupInfiniteScroll() {
  const sentinel = document.getElementById('products-sentinel');
  if (!sentinel || sentinel.dataset.observed) return;
  sentinel.dataset.observed = '1';
  const io = new IntersectionObserver(entries => {
    if (entries[0].isIntersecting) loadMoreProducts();
  }, { rootMargin: '700px' });
  io.observe(sentinel);
}

const catLabel = { figures: "Figures", keychains: "Keychains", stickers: "Stickers" };
let cart = [];
let editingCartKey = null;   // when set, the product modal edits this cart line's variant
let modalProduct = null;
let currentShopifyProductId = null;

// Products with options open the modal so a variant is actually chosen (no blind default add)
function openProductById(id, e) {
  if (e) e.stopPropagation();
  const p = products.find(x => x.id === id);
  if (p) openModal(p);
}

// True on phones/tablets — used to stop the hover-GIF popup from hijacking touch scrolling.
const IS_TOUCH = window.matchMedia('(hover: none), (pointer: coarse)').matches;

// Build one product-card DOM node (shared by the full render and the infinite-scroll append).
function createProductCard(p, show) {
  const div = document.createElement('div');
  div.className = 'product-card fade-up' + (show ? '' : ' hidden');
  div.dataset.handle = p.handle;
  const hasOpts = p.variants.length > 1 || p.variants[0].title !== 'Default Title';
  div.innerHTML = `
      <div class="product-img-wrap">
        <img src="${p.img}" alt="${p.title}" loading="lazy">
        ${p.badge ? `<div class="product-badge ${p.badge}">${p.badge}</div>` : ''}
        <div class="wishlist-btn" onclick="toggleWish(this, event)">♡</div>
        <div class="view-hint">👁 View details</div>
      </div>
      <div class="product-info">
        <div class="product-category">${catLabel[p.category] || p.category}</div>
        <div class="product-name">${p.title}</div>
        ${(() => { const totalQty = p.variants.reduce((s, v) => s + (v.inventory_quantity || 0), 0); const hasQtyData = p.variants.some(v => v.inventory_quantity !== null); if (!hasQtyData) { return p.variants.some(v => v.available) ? '<span class="stock-badge stock-in">In Stock</span>' : '<span class="stock-badge stock-out">Out of Stock</span>'; } if (totalQty <= 0) return '<span class="stock-badge stock-out">Out of Stock</span>'; if (totalQty <= 10) return `<span class="stock-badge stock-low">🔥 Only ${totalQty} left!</span>`; return '<span class="stock-badge stock-in">In Stock</span>'; })()}
        <div class="product-bottom">
          <div class="product-price">${formatPrice(p.price)}</div>
          ${hasOpts
            ? `<button class="add-to-cart" onclick="openProductById(${p.id}, event)">Select ▾</button>`
            : `<button class="add-to-cart" onclick="addToCart(${p.id}, this, event)">+ Add</button>`}
        </div>
      </div>
    `;
  // Track finger movement so a scroll-swipe that starts on a card isn't treated as a tap
  let cardTouchMoved = false, cardTsX = 0, cardTsY = 0;
  div.addEventListener('touchstart', e => {
    const t = e.touches[0]; cardTsX = t.clientX; cardTsY = t.clientY; cardTouchMoved = false;
  }, { passive: true });
  div.addEventListener('touchmove', e => {
    const t = e.touches[0];
    if (Math.abs(t.clientX - cardTsX) > 10 || Math.abs(t.clientY - cardTsY) > 10) cardTouchMoved = true;
  }, { passive: true });
  div.addEventListener('click', e => {
    if (e.target.closest('.add-to-cart') || e.target.closest('.wishlist-btn')) return;
    if (cardTouchMoved) return;   // it was a scroll, not a tap — don't open the modal
    openModal(p);
  });
  attachHoverEdit(div, p);
  setTimeout(() => div.classList.add('visible'), 50);
  return div;
}

function renderProducts(filter = 'all') {
  const grid = document.getElementById('products-grid');
  grid.innerHTML = '';
  products.forEach(p => {
    const show = filter === 'all' || p.category === filter;
    grid.appendChild(createProductCard(p, show));
  });
  shownProducts = PRODUCT_BATCH;
  applyProductBatch();
}

// ── PRODUCTS batch show-more/less (mirrors reviews pattern) ──
const PRODUCT_BATCH = 10;
let shownProducts = PRODUCT_BATCH;

function applyProductBatch() {
  const grid     = document.getElementById('products-grid');
  const btn      = document.getElementById('view-all-btn');
  const lessBtn  = document.getElementById('view-less-btn');
  if (!grid || !btn) return;

  const filtering = activeSearchQuery || (activeCategoryFilter && activeCategoryFilter !== 'all');
  const visible   = [...grid.querySelectorAll('.product-card:not(.hidden)')];

  // clear previous batch-hidden state
  visible.forEach(c => c.classList.remove('batch-hidden'));

  if (filtering || visible.length <= PRODUCT_BATCH) {
    btn.style.display = 'none';
    if (lessBtn) lessBtn.style.display = 'none';
    return;
  }

  // hide cards beyond current batch
  visible.slice(shownProducts).forEach(c => c.classList.add('batch-hidden'));

  const remaining = visible.length - shownProducts;

  // "show more" — hidden only once everything loaded so far is on screen
  if (remaining > 0) {
    btn.style.display = 'inline-flex';
    btn.textContent = `Show ${Math.min(PRODUCT_BATCH, remaining)} more ↓`;
    btn.onclick = () => {
      shownProducts = Math.min(shownProducts + PRODUCT_BATCH, visible.length);
      applyProductBatch();
    };
  } else {
    btn.style.display = 'none';
  }

  // "collapse all" — available the moment you're past the first batch, so it
  // never depends on reaching the end of an infinitely-scrolling catalogue
  if (lessBtn) {
    if (shownProducts > PRODUCT_BATCH) {
      lessBtn.style.display = 'inline-flex';
      lessBtn.textContent = '↑ Collapse all';
      lessBtn.onclick = () => {
        shownProducts = PRODUCT_BATCH;
        applyProductBatch();
        document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' });
      };
    } else {
      lessBtn.style.display = 'none';
    }
  }
}

let activeCategory = 'all';
function filterProducts(filter) {
  activeCategory = filter;
  document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
  event.target.classList.add('active');
  const cards = document.querySelectorAll('.product-card');
  cards.forEach(card => {
    const idx = Array.from(card.parentNode.children).indexOf(card);
    const p = products[idx];
    if (filter === 'all' || p.category === filter) {
      card.classList.remove('hidden');
    } else {
      card.classList.add('hidden');
    }
  });
  shownProducts = PRODUCT_BATCH;
  applyProductBatch();
}

let activeSearchQuery = '';
let activeCategoryFilter = 'all';

function applyFilters() {
  const q = activeSearchQuery.toLowerCase();
  document.querySelectorAll('.product-card').forEach((card, i) => {
    const p = products[i];
    if (!p) return;
    const categoryMatch = activeCategoryFilter === 'all' || p.category === activeCategoryFilter;
    const keywordMatch = !q || (p.fullTitle + ' ' + p.handle + ' ' + p.category).toLowerCase().includes(q);
    card.classList.toggle('hidden', !(categoryMatch && keywordMatch));
  });
  shownProducts = PRODUCT_BATCH;
  applyProductBatch();
}

function setSearchChip(keyword) {
  activeSearchQuery = keyword;
  const el = document.getElementById('active-filters');
  if (!keyword) { el.innerHTML = ''; return; }
  el.innerHTML = `<div class="search-chip">🔍 ${keyword}<button class="search-chip-x" onclick="removeSearchChip()" title="Remove filter">✕</button></div>`;
}

function removeSearchChip() {
  setSearchChip('');
  applyFilters();
}

document.querySelectorAll('.filter-btn').forEach(btn => {
  btn.addEventListener('click', function() {
    document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
    this.classList.add('active');
    activeCategoryFilter = this.dataset.filter;
    applyFilters();
  });
});

function addToCart(id, btn, e, overrideVariantId) {
  if (e) e.stopPropagation();
  const p = products.find(x => x.id === id);
  const vid = overrideVariantId || p.variantId;
  const cartKey = `${id}_${vid}`;
  const existing = cart.find(x => x._cartKey === cartKey);
  if (existing) {
    existing.qty++;
  } else {
    const variant = p.variants.find(v => v.id === vid) || p.variants[0];
    cart.push({ ...p, variantId: vid, price: variant.price, _cartKey: cartKey, qty: 1,
      title: p.variants.length > 1 && variant.title !== 'Default Title' ? p.title + ' · ' + stripVariantOrigin(variant.title) : p.title });
  }
  updateCartUI();
  showToast(`✅ ${p.title} added to cart!`);
  if (btn) {
    btn.textContent = '✓ Added';
    btn.classList.add('added');
    setTimeout(() => { btn.textContent = '+ Add'; btn.classList.remove('added'); }, 1500);
  }
}

function addFromModal() {
  if (modalProduct) {
    const p = { ...modalProduct, variantId: modalProduct._selectedVariantId || modalProduct.variantId };
    addToCart(modalProduct.id, null, null, p.variantId);
  }
  closeModalDirect();
}

// Open the product modal to change an existing cart line's variant
function editCartVariant(key) {
  const item = cart.find(x => (x._cartKey || x.id) === key);
  if (!item) return;
  const p = products.find(x => x.id === item.id);
  if (!p || p.variants.length <= 1) return;
  editingCartKey = key;
  openModal(p, item.variantId);
}

// Apply the variant picked in the modal back onto the cart line being edited
function updateCartVariant() {
  const key = editingCartKey;
  const item = cart.find(x => (x._cartKey || x.id) === key);
  if (!item || !modalProduct) { closeModalDirect(); return; }
  const newVid = modalProduct._selectedVariantId || modalProduct.variantId;
  const p = products.find(x => x.id === item.id) || modalProduct;
  const variant = p.variants.find(v => v.id === newVid) || p.variants[0];
  const newKey = `${item.id}_${newVid}`;
  if (newKey !== item._cartKey) {
    const newTitle = (p.variants.length > 1 && variant.title !== 'Default Title') ? p.title + ' · ' + stripVariantOrigin(variant.title) : p.title;
    const dup = cart.find(x => x._cartKey === newKey);
    if (dup) {                 // chosen variant already in cart → merge quantities
      dup.qty += item.qty;
      cart = cart.filter(x => x !== item);
    } else {
      item.variantId = newVid;
      item._cartKey = newKey;
      item.price = variant.price;
      item.title = newTitle;
      if (variant.img) item.img = variant.img;
    }
    showToast(`✅ Updated to ${variant.title !== 'Default Title' ? (stripVariantOrigin(variant.title) || p.title) : p.title}`);
  }
  closeModalDirect();
  updateCartUI();
}

// Same behavior on desktop AND mobile: redirect to the TikTok video search for this product.
// (On a phone with the TikTok app installed + logged in, the app may grab the link and show
// the home feed instead — that's TikTok's own link handling, not something the site controls.)
function tiktokVideosUrl(product) {
  const term = (product && product.fullTitle) ? product.fullTitle : 'anime merch';
  return 'https://www.tiktok.com/search/video?q=' + encodeURIComponent(term);
}

function watchTiktokModal() {
  if (!modalProduct) return;
  // Real example / unboxing videos — series hashtag on mobile, product search on desktop
  window.open(tiktokVideosUrl(modalProduct), '_blank');
}
function buyNowModal() {
  if (!modalProduct) return;
  const vid = modalProduct._selectedVariantId || modalProduct.variantId;
  closeModalDirect();
  window.open(`https://anime-lovers-9830.myshopify.com/cart/${vid}:1`, '_blank');
}

function updateCartUI() {
  const total = cart.reduce((s, x) => s + x.price * x.qty, 0);
  const count = cart.reduce((s, x) => s + x.qty, 0);
  const cartCountEl = document.getElementById('cart-count');
  cartCountEl.textContent = count;
  cartCountEl.style.display = count > 0 ? 'flex' : 'none';
  const itemsEl = document.getElementById('cart-items');
  const footer = document.getElementById('cart-footer');

  if (cart.length === 0) {
    itemsEl.innerHTML = `<div class="cart-empty">
      <div class="cart-empty-icon">🌊</div>
      <p>Your cart is empty.<br>Here's what you can unlock:</p>
      <div class="cart-empty-goals">
        <div class="cart-empty-goal">🎁 <b>Buy 2, get 1 FREE</b> — the cheapest item in your cart</div>
        <div class="cart-empty-goal">🚚 Spend <b>${formatPrice(60)}</b> → <b>FREE shipping</b></div>
        <div class="cart-empty-goal">🏷️ A sale is auto-applied at checkout — no codes</div>
      </div>
      <button class="checkout-btn" style="margin-top:18px" onclick="toggleCart();scrollToProducts()">Start shopping →</button>
    </div>`;
    footer.style.display = 'none';
  } else {
    footer.style.display = 'block';

    // Allocate free units (cheapest units are free) — drives BOTH the line price and the discount
    const allUnits = [];
    cart.forEach((x, idx) => { for (let i = 0; i < x.qty; i++) allUnits.push({ price: x.price, title: x.title, idx }); });
    allUnits.sort((a, b) => a.price - b.price);
    const freeCount = Math.floor(allUnits.length / BOGO_GROUP);
    const freeUnits = allUnits.slice(0, freeCount);
    const bogoValue = freeUnits.reduce((s, u) => s + u.price, 0);
    const freeByLine = {};
    freeUnits.forEach(u => { freeByLine[u.idx] = (freeByLine[u.idx] || 0) + 1; });

    itemsEl.innerHTML = cart.map((item, idx) => {
      const freeQty = freeByLine[idx] || 0;
      const paidQty = item.qty - freeQty;
      const key = item._cartKey || item.id;
      const editable = item.variants && item.variants.length > 1;
      let priceHtml;
      if (freeQty > 0 && paidQty === 0) priceHtml = `<s class="cart-strike">${formatPrice(item.price * item.qty)}</s> <span class="cart-free-pill">FREE</span>`;
      else if (freeQty > 0) priceHtml = `${formatPrice(item.price * paidQty)} <span class="cart-free-pill">${freeQty} FREE</span>`;
      else priceHtml = formatPrice(item.price * item.qty);
      return `
      <div class="cart-item${freeQty > 0 ? ' cart-item-hasfree' : ''}${editable ? ' cart-item-editable' : ''}">
        <img class="cart-item-img" src="${item.img}" alt="${item.title}"${editable ? ` onclick="editCartVariant('${key}')"` : ''}>
        <div class="cart-item-info">
          <div class="cart-item-name"${editable ? ` onclick="editCartVariant('${key}')"` : ''}>${item.title}</div>
          ${editable ? `<button class="cart-variant-change" onclick="editCartVariant('${key}')">Change option ▾</button>` : ''}
          <div class="cart-item-controls">
            <div class="qty-controls">
              <button class="qty-btn" onclick="changeQty('${key}', -1)">−</button>
              <div class="qty-num">${item.qty}</div>
              <button class="qty-btn" onclick="changeQty('${key}', 1)">+</button>
            </div>
            <div class="cart-item-price">${priceHtml}</div>
          </div>
        </div>
        <button class="cart-item-remove" onclick="removeFromCart('${key}')">🗑</button>
      </div>`;
    }).join('');

    // ── Discounts STACK: Buy 2 Get 1 Free (above) then the % sale on the rest ──
    const ev = activeEventNow();
    const pct = ev && ev.pct ? ev.pct : 0;
    const pctValue = pct * (total - bogoValue);
    const discount = bogoValue + pctValue;
    const discountedTotal = Math.max(0, total - discount);

    let discountsHtml = '';
    if (bogoValue > 0.001) discountsHtml += `<div class="cart-subtotal cart-discount-line"><span>🎁 Buy 2 Get 1 Free</span><span>−${formatPrice(bogoValue)}</span></div>`;
    if (pctValue > 0.001) discountsHtml += `<div class="cart-subtotal cart-discount-line"><span>🎉 ${ev ? ev.text.split('—')[0].trim() : 'Sale'}</span><span>−${formatPrice(pctValue)}</span></div>`;
    document.getElementById('cart-discounts').innerHTML = discountsHtml;
    document.getElementById('cart-subtotal-val').textContent = formatPrice(total);
    document.getElementById('cart-total-val').textContent = formatPrice(discountedTotal);

    // ── Free-item progress + the actual free item(s) shown explicitly ──
    const inGroup = allUnits.length % BOGO_GROUP;          // 0, 1, 2
    const toNext = inGroup === 0 ? BOGO_GROUP : (BOGO_GROUP - inGroup);
    const fill = allUnits.length === 0 ? 0 : (inGroup === 0 ? 100 : (inGroup / BOGO_GROUP) * 100);
    let freeBanner = '';
    if (freeUnits.length) {
      freeBanner = `<div class="cart-free-unlocked">🎉 ${freeUnits.length} FREE item${freeUnits.length > 1 ? 's' : ''} added to your order!` +
        freeUnits.map(u => `<div class="cart-free-row"><span>🎁 ${u.title}</span><span class="cart-free-tag"><s>${formatPrice(u.price)}</s> FREE</span></div>`).join('') + `</div>`;
    }
    let msg;
    if (inGroup === 2)      msg = `🎁 Add 1 more — your cheapest item is then FREE!`;
    else if (inGroup === 1) msg = `🎁 Add 1 more, then your next item is FREE${freeCount > 0 ? ' again' : ''}!`;
    else                    msg = `🎉 FREE item added to your order! Keep shopping for more 🎁`;
    document.getElementById('cart-bogo').innerHTML =
      freeBanner + `<div class="cart-bogo-msg">${msg}</div><div class="cart-bogo-track"><div class="cart-bogo-fill" style="width:${fill}%"></div></div>`;

    // ── Free-shipping progress (threshold in AUD base currency) ──
    const FREE_SHIP = 60;
    const toFreeShip = Math.max(0, FREE_SHIP - total);
    const fsFill = Math.min(100, (total / FREE_SHIP) * 100);
    document.getElementById('cart-freeship').innerHTML = toFreeShip > 0
      ? `<div class="cart-bogo-msg">🚚 Spend ${formatPrice(toFreeShip)} more for FREE shipping!</div><div class="cart-bogo-track"><div class="cart-bogo-fill" style="width:${fsFill}%"></div></div>`
      : `<div class="cart-bogo-msg">🎉 You've unlocked FREE shipping!</div><div class="cart-bogo-track"><div class="cart-bogo-fill" style="width:100%"></div></div>`;
    const shipEl = document.getElementById('cart-shipping-val');
    if (shipEl) shipEl.innerHTML = toFreeShip > 0 ? 'Calculated at checkout' : '<strong style="color:var(--teal)">FREE 🎉</strong>';

    // ── Savings highlight ──
    const savEl = document.getElementById('cart-savings');
    if (discount > 0.001) { savEl.style.display = 'block'; savEl.innerHTML = `💰 You're saving ${formatPrice(discount)} today!`; }
    else { savEl.style.display = 'none'; }

    // ── Complete the set: suggest items (same anime first) ──
    const suggestEl = document.getElementById('cart-suggest');
    const inCartIds = new Set(cart.map(x => x.id));
    const cartSeries = new Set(cart.map(x => getAnimeSeries({ handle: x.handle, fullTitle: x.fullTitle })));
    let sugg = products.filter(p => !inCartIds.has(p.id));
    sugg.sort((a, b) => (cartSeries.has(getAnimeSeries({ handle: a.handle, fullTitle: a.fullTitle })) ? 0 : 1) - (cartSeries.has(getAnimeSeries({ handle: b.handle, fullTitle: b.fullTitle })) ? 0 : 1));
    sugg = sugg.slice(0, 4);
    if (sugg.length && (toFreeShip > 0 || toNext <= 2)) {
      suggestEl.style.display = 'block';
      suggestEl.innerHTML = `<div class="cart-suggest-title">✨ Complete your haul</div><div class="cart-suggest-row">` +
        sugg.map(p => `<div class="cart-suggest-card" onclick="addToCart(${p.id}, null, event)"><img src="${p.img}" alt="${p.title}" loading="lazy"><div class="cart-suggest-name">${p.title}</div><div class="cart-suggest-price">${formatPrice(p.price)}</div></div>`).join('') + `</div>`;
    } else { suggestEl.style.display = 'none'; }
  }
}

function changeQty(key, delta) {
  const item = cart.find(x => (x._cartKey || x.id) === key);
  if (!item) return;
  item.qty += delta;
  if (item.qty <= 0) cart = cart.filter(x => (x._cartKey || x.id) !== key);
  updateCartUI();
}

function removeFromCart(key) {
  cart = cart.filter(x => (x._cartKey || x.id) !== key);
  updateCartUI();
}

function toggleCart() {
  document.getElementById('cart-panel').classList.toggle('open');
  document.getElementById('cart-overlay').classList.toggle('open');
}

function checkout() {
  if (cart.length === 0) return;
  const cartPath = cart.map(item => `${item.variantId}:${item.qty}`).join(',');
  let url = `https://anime-lovers-9830.myshopify.com/cart/${cartPath}`;
  try { if (localStorage.getItem('fannest_signup')) url += '?discount=FANNEST10'; } catch(e) {}
  window.open(url, '_blank');
}


// Strip ship-from / origin segments (e.g. "China Mainland") out of an AliExpress variant
// title so the sourcing is never exposed to buyers. Titles look like "SKU-03 / China Mainland / 6 cm".
function stripVariantOrigin(title) {
  if (!title) return title;
  const ORIGIN_RE = /china|mainland|guangdong|zhejiang|shenzhen|fujian|yiwu|\bcn\b/i;
  const parts = String(title).split(/\s*[\/|]\s*/).map(p => p.trim()).filter(p => p && !ORIGIN_RE.test(p));
  return parts.join(' / ').trim();
}

// Turn unhelpful variant codes ("1", "Default Title", "Random one") into friendly labels.
// Buyers pick by the swatch image, so the label is just a backup.
function cleanVariantName(title, i) {
  const t = (title || '').toLowerCase().trim();
  if (!t || t === 'default title' || t === 'random one' || t === 'random-one' || /^\d+$/.test(t)) return 'Style ' + (i + 1);
  const pcs = t.match(/^(\d+)\s*pcs?$/);
  if (pcs) return pcs[1] + '-Piece Set';
  return stripVariantOrigin(title) || ('Style ' + (i + 1));
}

// Pull the clean "Key: Value" spec rows out of the raw AliExpress body_html
// (drops the promo images and Chinese marketing copy — keep only the important stuff)
function parseSpecs(bodyHtml) {
  if (!bodyHtml) return [];
  const tmp = document.createElement('div');
  tmp.innerHTML = bodyHtml;
  // Drop dropshipping/sourcing noise and uninformative rows
  const KEY_BLOCK = new Set(['origin','place of origin','choice','semi_choice','semi-choice','high-concerned chemical','certification','cn','model number']);
  const VAL_BLOCK = new Set(['yes','no','none','n/a','na','-']);
  const rows = [];
  const seen = new Set();
  tmp.querySelectorAll('p, li, tr').forEach(el => {
    const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text || text.length > 90) return;
    const m = text.match(/^([^:：]{2,40})[:：]\s*(.+)$/);
    if (!m) return;
    const key = m[1].trim();
    const val = m[2].trim();
    if (!val || val.length > 60) return;
    if (/[一-鿿]/.test(key) || /[一-鿿]/.test(val)) return; // skip CJK promo
    const k = key.toLowerCase();
    if (KEY_BLOCK.has(k) || VAL_BLOCK.has(val.toLowerCase())) return;
    if (seen.has(k)) return;
    seen.add(k);
    rows.push({ key, val });
  });
  return rows.slice(0, 12);
}

function renderSpecs(bodyHtml) {
  const toggle = document.getElementById('modal-spec-toggle');
  const body = document.getElementById('modal-spec-body');
  toggle.classList.remove('open');
  body.classList.remove('open');
  body.innerHTML = '';
  const specs = parseSpecs(bodyHtml);
  if (!specs.length) { toggle.style.display = 'none'; return; }
  specs.forEach(s => {
    const row = document.createElement('div'); row.className = 'modal-spec-row';
    const k = document.createElement('div'); k.className = 'modal-spec-key'; k.textContent = s.key;
    const v = document.createElement('div'); v.className = 'modal-spec-val'; v.textContent = s.val;
    row.appendChild(k); row.appendChild(v); body.appendChild(row);
  });
  toggle.style.display = 'flex';
}

function toggleSpecs() {
  const toggle = document.getElementById('modal-spec-toggle');
  const body = document.getElementById('modal-spec-body');
  const open = body.classList.toggle('open');
  toggle.classList.toggle('open', open);
}

function openModal(p, preselectVariantId) {
  const selV = p.variants.find(v => v.id === preselectVariantId) || p.variants[0];
  modalProduct = { ...p, _selectedVariantId: selV.id };
  currentShopifyProductId = p.id;
  const mainImg = document.getElementById('modal-img');
  mainImg.src = selV.img || p.images[0] || p.img;
  document.getElementById('modal-cat').textContent = catLabel[p.category] || p.category;
  document.getElementById('modal-title').textContent = p.title;
  document.getElementById('modal-price').textContent = formatPrice(selV.price);
  // Add-to-cart mode vs "edit this cart line's variant" mode
  const addBtn = document.getElementById('modal-add-btn');
  const buyBtn = document.getElementById('modal-buy-btn');
  const addLabel = document.getElementById('modal-add-label');
  if (editingCartKey) {
    if (addLabel) addLabel.textContent = 'Update item';
    addBtn.setAttribute('onclick', 'updateCartVariant()');
    if (buyBtn) buyBtn.style.display = 'none';
  } else {
    if (addLabel) addLabel.textContent = 'Add to Cart';
    addBtn.setAttribute('onclick', 'addFromModal()');
    if (buyBtn) buyBtn.style.display = '';
  }

  // Series info (needed for both thumbnails and variants)
  const seriesNames = { rezero:'re zero', mha:'my hero academia', demonslayer:'demon slayer', onepiece:'one piece', ghibli:'studio ghibli', wistoria:'wistoria', general:'anime' };
  const seriesKey = getAnimeSeries(p);
  const seriesName = seriesNames[seriesKey] || 'anime';
  const skipTitles = new Set(['default title','random one','random-one','4pcs','7pcs']);

  // Thumbnails
  const thumbsEl = document.getElementById('modal-thumbs');
  thumbsEl.innerHTML = '';
  (p.images || [p.img]).forEach((src, i) => {
    const img = document.createElement('img');
    img.src = src;
    img.className = 'modal-thumb' + (i === 0 ? ' active' : '');
    img.onclick = () => {
      mainImg.src = src;
      thumbsEl.querySelectorAll('.modal-thumb').forEach(t => t.classList.remove('active'));
      img.classList.add('active');
    };

    // Find if this image belongs to a specific variant
    thumbsEl.appendChild(img);
  });

  // Variants
  const variantsEl = document.getElementById('modal-variants');
  const btnsEl = document.getElementById('modal-variant-btns');
  const labelEl = document.getElementById('modal-variants-label');
  btnsEl.innerHTML = '';
  const hasOptions = p.variants.length > 1 || p.variants[0].title !== 'Default Title';


  function variantTiktokKeyword(variantTitle) {
    const t = variantTitle.toLowerCase().trim();
    // If it's a number-only or a skip title, use the series name only
    if (skipTitles.has(t) || /^\d+$/.test(t)) return seriesName + ' anime edit';
    return variantTitle + ' ' + seriesName + ' anime edit';
  }

  function showVariantGif(btn, variantTitle) {
    const { gifs, query } = animeSearch[seriesKey];
    const fallbackId = gifs[Math.floor(Math.random() * gifs.length)];
    editGif.src = `https://media.giphy.com/media/${fallbackId}/giphy.gif`;
    fetchGiphyGif(query, gifs).then(url => { editGif.src = url; });
    editLabel.textContent = stripVariantOrigin(variantTitle) || variantTitle;
    currentTiktokUrl = tiktokVideosUrl(p);

    const rect = btn.getBoundingClientRect();
    const popupW = 190, popupH = 338, margin = 12;
    let left = rect.right + margin;
    let top  = rect.top - popupH / 2 + rect.height / 2;
    if (left + popupW > window.innerWidth - 10) left = rect.left - popupW - margin;
    top = Math.max(10, Math.min(top, window.innerHeight - popupH - 10));
    editPopup.style.left = left + 'px';
    editPopup.style.top  = top  + 'px';
    cancelHide();
    editPopup.classList.add('visible');
  }

  if (hasOptions) {
    labelEl.textContent = p.handle.includes('color') ? 'Pick your colour 👇' : 'Pick your style 👇';
    variantsEl.style.display = 'block';
    p.variants.forEach((v, i) => {
      const btn = document.createElement('button');
      btn.className = 'variant-swatch' + (i === 0 ? ' active' : '') + (v.available ? '' : ' oos');
      const label = cleanVariantName(v.title, i);
      const qty = v.inventory_quantity;
      const stock = qty === null ? '' : qty <= 0 ? 'Sold out' : qty <= 5 ? `Only ${qty} left` : '';
      const imgSrc = v.img || p.images[0] || p.img;
      btn.innerHTML = `
        <img class="variant-swatch-img" src="${imgSrc}" alt="${label}" loading="lazy">
        <span class="variant-swatch-label">${label}${stock ? `<em>${stock}</em>` : ''}</span>`;
      btn.onclick = () => {
        btnsEl.querySelectorAll('.variant-swatch').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        modalProduct._selectedVariantId = v.id;
        document.getElementById('modal-price').textContent = formatPrice(v.price);
        if (v.img) {
          mainImg.src = v.img;
          thumbsEl.querySelectorAll('.modal-thumb').forEach(t => t.classList.remove('active'));
          const match = [...thumbsEl.querySelectorAll('.modal-thumb')].find(t => t.src === v.img);
          if (match) match.classList.add('active');
        }
      };
      btnsEl.appendChild(btn);
    });
  } else {
    variantsEl.style.display = 'none';
  }


  renderSpecs(p.bodyHtml);
  document.getElementById('modal-overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
  loadReviews(p.handle, p.id);
}

function closeModal(e) {
  if (e.target === document.getElementById('modal-overlay')) closeModalDirect();
}

function closeModalDirect() {
  document.getElementById('modal-overlay').classList.remove('open');
  document.body.style.overflow = '';   // restore page scrolling
  modalProduct = null;
}

function toggleWish(btn, e) {
  e.stopPropagation();
  btn.classList.toggle('loved');
  btn.textContent = btn.classList.contains('loved') ? '♥' : '♡';
}

let _toastTimer = null;
function showToast(msg) {
  const t = document.getElementById('toast');
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(_toastTimer);
  _toastTimer = setTimeout(() => t.classList.remove('show'), 2500);
}
document.getElementById('toast').addEventListener('click', () => {
  document.getElementById('toast').classList.remove('show');
});

function scrollToProducts() {
  document.getElementById('products').scrollIntoView({ behavior: 'smooth' });
}

// Scroll-triggered fade-in
const observer = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
}, { threshold: 0.1 });
document.querySelectorAll('.fade-up').forEach(el => observer.observe(el));

// Bubbles
const bubbles = document.getElementById('bubbles');
for (let i = 0; i < 18; i++) {
  const b = document.createElement('div');
  b.className = 'bubble';
  const size = Math.random() * 60 + 10;
  b.style.cssText = `
    width: ${size}px; height: ${size}px;
    left: ${Math.random() * 100}%;
    animation-duration: ${Math.random() * 14 + 10}s;
    animation-delay: ${Math.random() * 8}s;
  `;
  bubbles.appendChild(b);
}

// ── ANIME EDIT HOVER POPUP ──
const animeSearch = {
  rezero:        { label: 'Re:Zero Edit',          tiktok: 're zero edit',               query: 're zero anime',              gifs: ['R36qPXXsR7AxnKRKq5','KHLnauIiHPLVxmfiUF','w1VXPbuLR8nBUwpjeA','DjZJeulfFBG31ZqaJU'] },
  mha:           { label: 'MHA Edit',              tiktok: 'my hero academia edit',      query: 'my hero academia anime',     gifs: ['11mKDvhPQK3TLW','tNj46thXqk3UNq5t3J','ow3FZxyKiVSPFHmrmu','xT9IgqTbGGmCBPB8Bu'] },
  demonslayer:   { label: 'Demon Slayer Edit',     tiktok: 'demon slayer edit',          query: 'demon slayer anime',         gifs: ['lsUWq3SQ3NLYusKJ4O','vLkErVIYNayLSZnLlS','l0MYEqEzwMWFCv8c4','3o7abDqcTcBGn9cX5u'] },
  onepiece:      { label: 'One Piece Edit',        tiktok: 'one piece edit',             query: 'one piece anime',            gifs: ['s1hPpH61mVh0NbZEEO','BqbbbdMDXLjLgt2hgY','uvCxJCIdf1BcY','3oEjI6SIIHBdRxXI40'] },
  ghibli:        { label: 'Ghibli Edit',           tiktok: 'studio ghibli edit',         query: 'studio ghibli anime',        gifs: ['6mvRz2t6GPugGTNxLb','l0MYt9jFAGRCFzHRS','26BRL7Y6eFTQr3gLu'] },
  wistoria:      { label: 'Wistoria Edit',         tiktok: 'wistoria anime edit',        query: 'wistoria',             gifs: ['tNj46thXqk3UNq5t3J','ow3FZxyKiVSPFHmrmu'] },
  naruto:        { label: 'Naruto Edit',           tiktok: 'naruto edit',                query: 'naruto anime',               gifs: ['Ju7l5y9osyymQ','3oEjI6SIIHBdRxXI40','l4FGnxHpFtCdJbHlS','xT9IgqlW0YglZCxuU0'] },
  attackontitan: { label: 'AOT Edit',              tiktok: 'attack on titan edit',       query: 'attack on titan anime',      gifs: ['YKITEWEFBxjuejM68q','l4FGnxHpFtCdJbHlS','3oEjI6SIIHBdRxXI40'] },
  jjk:           { label: 'JJK Edit',              tiktok: 'jujutsu kaisen edit',        query: 'jujutsu kaisen anime',       gifs: ['tNj46thXqk3UNq5t3J','ow3FZxyKiVSPFHmrmu','xT9IgqTbGGmCBPB8Bu'] },
  dragonball:    { label: 'Dragon Ball Edit',      tiktok: 'dragon ball edit',           query: 'dragon ball anime',          gifs: ['26BRuo6sLetdllPAQ','BqbbbdMDXLjLgt2hgY','fAHkKdXihLkwTZJMsM'] },
  bleach:        { label: 'Bleach Edit',           tiktok: 'bleach anime edit',          query: 'bleach anime',               gifs: ['DjZJeulfFBG31ZqaJU','KHLnauIiHPLVxmfiUF','l0MYEqEzwMWFCv8c4'] },
  mushokutensei: { label: 'Mushoku Tensei Edit',   tiktok: 'mushoku tensei edit',        query: 'mushoku tensei anime',       gifs: ['w1VXPbuLR8nBUwpjeA','R36qPXXsR7AxnKRKq5','tNj46thXqk3UNq5t3J'] },
  bluelock:      { label: 'Blue Lock Edit',        tiktok: 'blue lock edit',             query: 'blue lock anime',            gifs: ['s1hPpH61mVh0NbZEEO','tNj46thXqk3UNq5t3J','xT9IgqlW0YglZCxuU0'] },
  chainsawman:   { label: 'Chainsaw Man Edit',     tiktok: 'chainsaw man edit',          query: 'chainsaw man anime',         gifs: ['l0MYEqEzwMWFCv8c4','tNj46thXqk3UNq5t3J','ow3FZxyKiVSPFHmrmu'] },
  sololeveling:  { label: 'Solo Leveling Edit',    tiktok: 'solo leveling edit',         query: 'solo leveling anime',        gifs: ['xT9IgqTbGGmCBPB8Bu','tNj46thXqk3UNq5t3J','YKITEWEFBxjuejM68q'] },
  vinlandsaga:   { label: 'Vinland Saga Edit',     tiktok: 'vinland saga edit',          query: 'vinland saga anime',         gifs: ['YKITEWEFBxjuejM68q','l4FGnxHpFtCdJbHlS','3oEjI6SIIHBdRxXI40'] },
  hxh:           { label: 'HxH Edit',              tiktok: 'hunter x hunter edit',       query: 'hunter x hunter anime',      gifs: ['tNj46thXqk3UNq5t3J','ow3FZxyKiVSPFHmrmu','xT9IgqlW0YglZCxuU0'] },
  fairytail:     { label: 'Fairy Tail Edit',       tiktok: 'fairy tail edit',            query: 'fairy tail anime',           gifs: ['26BRuo6sLetdllPAQ','s1hPpH61mVh0NbZEEO','BqbbbdMDXLjLgt2hgY'] },
  sao:           { label: 'SAO Edit',              tiktok: 'sword art online edit',      query: 'sword art online anime',     gifs: ['xT9IgqTbGGmCBPB8Bu','tNj46thXqk3UNq5t3J','ow3FZxyKiVSPFHmrmu'] },
  fullmetal:     { label: 'FMA Edit',              tiktok: 'fullmetal alchemist edit',   query: 'fullmetal alchemist anime',  gifs: ['l0MYEqEzwMWFCv8c4','26BRuo6sLetdllPAQ','lsUWq3SQ3NLYusKJ4O'] },
  deathnote:     { label: 'Death Note Edit',       tiktok: 'death note edit',            query: 'death note anime',           gifs: ['DjZJeulfFBG31ZqaJU','KHLnauIiHPLVxmfiUF','R36qPXXsR7AxnKRKq5'] },
  tokyoghoul:    { label: 'Tokyo Ghoul Edit',      tiktok: 'tokyo ghoul edit',           query: 'tokyo ghoul anime',          gifs: ['lsUWq3SQ3NLYusKJ4O','vLkErVIYNayLSZnLlS','tNj46thXqk3UNq5t3J'] },
  blackclover:   { label: 'Black Clover Edit',     tiktok: 'black clover edit',          query: 'black clover anime',         gifs: ['26BRuo6sLetdllPAQ','s1hPpH61mVh0NbZEEO','ow3FZxyKiVSPFHmrmu'] },
  haikyuu:       { label: 'Haikyuu Edit',          tiktok: 'haikyuu edit',               query: 'haikyuu anime',              gifs: ['xT9IgqlW0YglZCxuU0','s1hPpH61mVh0NbZEEO','BqbbbdMDXLjLgt2hgY'] },
  toaru:         { label: 'Frieren Edit',          tiktok: 'frieren anime edit',         query: 'frieren anime',              gifs: ['6mvRz2t6GPugGTNxLb','w1VXPbuLR8nBUwpjeA','R36qPXXsR7AxnKRKq5'] },
  tensura:       { label: 'Slime Edit',            tiktok: 'that time i got reincarnated as a slime edit', query: 'tensura slime anime', gifs: ['tNj46thXqk3UNq5t3J','ow3FZxyKiVSPFHmrmu','xT9IgqTbGGmCBPB8Bu'] },
  overlord:      { label: 'Overlord Edit',         tiktok: 'overlord anime edit',        query: 'overlord anime',             gifs: ['YKITEWEFBxjuejM68q','DjZJeulfFBG31ZqaJU','lsUWq3SQ3NLYusKJ4O'] },
  konosuba:      { label: 'KonoSuba Edit',         tiktok: 'konosuba edit',              query: 'konosuba anime',             gifs: ['s1hPpH61mVh0NbZEEO','26BRuo6sLetdllPAQ','BqbbbdMDXLjLgt2hgY'] },
  codegeass:     { label: 'Code Geass Edit',       tiktok: 'code geass edit',            query: 'code geass anime',           gifs: ['DjZJeulfFBG31ZqaJU','KHLnauIiHPLVxmfiUF','YKITEWEFBxjuejM68q'] },
  evangelion:    { label: 'Evangelion Edit',       tiktok: 'neon genesis evangelion edit', query: 'neon genesis evangelion', gifs: ['l0MYEqEzwMWFCv8c4','lsUWq3SQ3NLYusKJ4O','R36qPXXsR7AxnKRKq5'] },
  general:       { label: 'Anime Edit',            tiktok: 'anime edit',                 query: 'anime',                      gifs: ['s1hPpH61mVh0NbZEEO','11mKDvhPQK3TLW','lsUWq3SQ3NLYusKJ4O','tNj46thXqk3UNq5t3J'] },
};

function getAnimeSeries(p) {
  const t = (p.handle + ' ' + p.fullTitle).toLowerCase();
  if (t.includes('mushoku') || t.includes('rudeus') || t.includes('eris') || t.includes('sylphie'))                                                                              return 'mushokutensei';
  if (t.includes('wistoria'))                                                                                                                                                     return 'wistoria';
  if (t.includes('chainsaw') || t.includes('denji') || t.includes('makima') || t.includes('power') && t.includes('csm'))                                                         return 'chainsawman';
  if (t.includes('solo leveling') || t.includes('sololeveling') || t.includes('sung jin') || t.includes('jinwoo') || t.includes('sung-jin'))                                    return 'sololeveling';
  if (t.includes('vinland') || t.includes('thorfinn') || t.includes('askeladd') || t.includes('canute'))                                                                         return 'vinlandsaga';
  if (t.includes('hunter x hunter') || t.includes('hxh') || t.includes('killua') || t.includes('gon ') || t.includes('hisoka') || t.includes('kurapika') || t.includes('leorio')) return 'hxh';
  if (t.includes('fairy tail') || t.includes('natsu') || t.includes('erza') || t.includes('lucy') && t.includes('fairy') || t.includes('gray ') && t.includes('fairy'))         return 'fairytail';
  if (t.includes('sword art') || t.includes('sao') || t.includes('kirito') || t.includes('asuna') || t.includes('sinon'))                                                        return 'sao';
  if (t.includes('fullmetal') || t.includes('full metal') || t.includes('edward elric') || t.includes('alphonse') || t.includes('roy mustang'))                                  return 'fullmetal';
  if (t.includes('death note') || t.includes('deathnote') || t.includes('light yagami') || t.includes('ryuk') || t.includes('l lawliet') || t.includes('kira'))                  return 'deathnote';
  if (t.includes('tokyo ghoul') || t.includes('tokyoghoul') || t.includes('kaneki') || t.includes('touka') || t.includes('rize'))                                                return 'tokyoghoul';
  if (t.includes('black clover') || t.includes('blackclover') || t.includes('asta') || t.includes('yuno') || t.includes('noelle') && t.includes('clover'))                      return 'blackclover';
  if (t.includes('haikyuu') || t.includes('haikyu') || t.includes('hinata') && t.includes('volleyball') || t.includes('kageyama') || t.includes('shoyo'))                       return 'haikyuu';
  if (t.includes('frieren') || t.includes('fern ') || t.includes('stark ') && t.includes('anime'))                                                                               return 'toaru';
  if (t.includes('slime') || t.includes('tensura') || t.includes('rimuru') || t.includes('reincarnated as a slime'))                                                             return 'tensura';
  if (t.includes('overlord') || t.includes('ainz') || t.includes('albedo') || t.includes('shalltear'))                                                                           return 'overlord';
  if (t.includes('konosuba') || t.includes('kono subarashii') || t.includes('kazuma') || t.includes('aqua ') && t.includes('anime') || t.includes('megumin') || t.includes('darkness') && t.includes('anime')) return 'konosuba';
  if (t.includes('code geass') || t.includes('codegeass') || t.includes('lelouch') || t.includes('suzaku') || t.includes('c.c.') || t.includes('zero') && t.includes('geass')) return 'codegeass';
  if (t.includes('evangelion') || t.includes('eva ') || t.includes('shinji') || t.includes('rei ayanami') || t.includes('asuka') || t.includes('nerv'))                          return 'evangelion';
  if (t.includes('re-zero') || t.includes('rezero') || t.includes('re zero') || t.includes('rem ') || t.includes('emilia') || t.includes('beatrice') || t.includes('subaru'))   return 'rezero';
  if (t.includes('jujutsu') || t.includes('jjk') || t.includes('gojo') || t.includes('sukuna') || t.includes('itadori') || t.includes('yuji') || t.includes('megumi') || t.includes('nobara')) return 'jjk';
  if (t.includes('demon slayer') || t.includes('kimetsu') || t.includes('tanjiro') || t.includes('nezuko') || t.includes('zenitsu') || t.includes('inosuke') || t.includes('rengoku')) return 'demonslayer';
  if (t.includes('hero academia') || t.includes('mha') || t.includes('midoriya') || t.includes('bakugo') || t.includes('deku') || t.includes('todoroki') || t.includes('all might')) return 'mha';
  if (t.includes('attack on titan') || t.includes('shingeki') || t.includes('eren') || t.includes('levi') || t.includes('mikasa') || t.includes('armin'))                        return 'attackontitan';
  if (t.includes('dragon ball') || t.includes('dragonball') || t.includes('goku') || t.includes('vegeta') || t.includes('gohan') || t.includes('frieza'))                        return 'dragonball';
  if (t.includes('one piece') || t.includes('luffy') || t.includes('zoro') || t.includes('nami') || t.includes('sanji') || t.includes('usopp') || t.includes('robin'))          return 'onepiece';
  if (t.includes('naruto') || t.includes('sasuke') || t.includes('kakashi') || t.includes('hokage') || t.includes('sakura') || t.includes('itachi'))                             return 'naruto';
  if (t.includes('bleach') || t.includes('ichigo') || t.includes('rukia') || t.includes('aizen') || t.includes('byakuya') || t.includes('renji'))                                return 'bleach';
  if (t.includes('blue lock') || t.includes('bluelock') || t.includes('isagi') || t.includes('bachira') || t.includes('nagi') || t.includes('reo'))                              return 'bluelock';
  if (t.includes('totoro') || t.includes('ghibli') || t.includes('spirited') || t.includes('howl') || t.includes('chihiro'))                                                     return 'ghibli';
  return 'general';
}

async function fetchGiphyGif(query, fallbacks) {
  try {
    const offset = Math.floor(Math.random() * 40);
    const res = await fetch(`https://api.giphy.com/v1/gifs/search?api_key=${GIPHY_KEY}&q=${encodeURIComponent(query)}&limit=15&offset=${offset}&rating=pg`);
    const data = await res.json();
    if (data.data && data.data.length > 0) {
      const id = data.data[Math.floor(Math.random() * data.data.length)].id;
      return `https://media.giphy.com/media/${id}/giphy.gif`;
    }
  } catch(e) { /* fall through */ }
  const fallbackId = fallbacks[Math.floor(Math.random() * fallbacks.length)];
  return `https://media.giphy.com/media/${fallbackId}/giphy.gif`;
}

const editPopup = document.getElementById('edit-popup');
const editGif   = document.getElementById('edit-gif');
const editLabel = document.getElementById('edit-popup-name');
let currentTiktokUrl = '#';

function openTiktok() {
  window.open(currentTiktokUrl, '_blank');
}
let hoverTimer = null;
let activeCard = null;

let _editCycle = null;
function showEditPopup(card, p) {
  // Show the actual product (cycles its photos) and link to real product videos on TikTok
  editLabel.textContent = p.title;
  const imgs = (p.images && p.images.length) ? p.images : [p.img];
  editGif.src = imgs[0];
  clearInterval(_editCycle);
  if (imgs.length > 1) {
    let i = 0;
    _editCycle = setInterval(() => { i = (i + 1) % imgs.length; editGif.src = imgs[i]; }, 1200);
  }
  currentTiktokUrl = tiktokVideosUrl(p);

  const rect = card.getBoundingClientRect();
  const popupW = 190, popupH = 338, margin = 12;
  let left = rect.right + margin;
  let top  = rect.top + (rect.height - popupH) / 2;
  if (left + popupW > window.innerWidth - 10) left = rect.left - popupW - margin;
  top = Math.max(10, Math.min(top, window.innerHeight - popupH - 10));
  editPopup.style.left = left + 'px';
  editPopup.style.top  = top  + 'px';
  editPopup.classList.add('visible');
}

let hideTimer = null;

function scheduleHide() {
  hideTimer = setTimeout(() => {
    editPopup.classList.remove('visible');
    clearInterval(_editCycle);
    setTimeout(() => { if (!editPopup.classList.contains('visible')) editGif.src = ''; }, 300);
    activeCard = null;
  }, 200);
}

function cancelHide() {
  clearTimeout(hideTimer);
}

function attachHoverEdit(card, p) {
  card.addEventListener('mouseenter', () => {
    cancelHide();
    activeCard = card;
    hoverTimer = setTimeout(() => {
      if (activeCard === card) showEditPopup(card, p);
    }, 500);
  });
  card.addEventListener('mouseleave', (e) => {
    clearTimeout(hoverTimer);
    if (!editPopup.contains(e.relatedTarget)) scheduleHide();
  });
  // On touch devices, do NOT bind touchstart here: the old preventDefault() blocked page
  // scrolling whenever a swipe started on a card. Let taps open the modal and swipes scroll.
  if (IS_TOUCH) return;
  card.addEventListener('touchstart', (e) => {
    if (e.target.closest('.add-to-cart') || e.target.closest('.wishlist-btn')) return;
    if (editPopup.classList.contains('visible') && activeCard === card) {
      scheduleHide();
      return;
    }
    e.preventDefault();
    cancelHide();
    activeCard = card;
    showEditPopup(card, p);
  }, { passive: false });
}

editPopup.addEventListener('mouseenter', cancelHide);
editPopup.addEventListener('mouseleave', (e) => {
  if (!activeCard || !activeCard.contains(e.relatedTarget)) scheduleHide();
});

// Theme toggle
function toggleTheme() {
  document.body.classList.toggle('light-mode');
  localStorage.setItem('theme', document.body.classList.contains('light-mode') ? 'light' : 'dark');
  // keep the hero GIF playing in both light and dark mode
  setHeroGif();
}
if (localStorage.getItem('theme') === 'light') document.body.classList.add('light-mode');

// ── HERO BACKGROUND FIGHTING GIF ──
const heroFightGifs = [
  // Demon Slayer
  '721us8U63qA4VgOJ1r','iR6kCwjEx7hXInz2bp','MKv62NSu1YkR5JORSa',
  'Ri3j3y8GOpgGVHwsyc','Z9zpwcKoRaX349FKEm','tUYcVoyPkykMQPDH6d',
  // My Hero Academia
  '50WPPBMNyOQEUzajii','r62UTDZuc19dpm36RB','3o7bujtrSVR0UYYGwU',
  'xUA7bdmmuDruZ7f86k','41xdgIzz7n9i9BIl3T','iNYPI6WZe16Z6fgXrv',
  // One Piece
  'qkwdCmiBiJQkC7hcF5','eoB8kULBlnpmaxHqJQ','tGof1bKA77B5scfBpO',
  'ozIfYzaC2yGkBL3seo','7S5mOq10DXZ4Eg4IDH',
  // Attack on Titan
  '11HeubLHnQJSAU','IUiLMgsBmb3zi','zwPRprvrP4Lm0',
  'yOfzSP0g9lCOhGBXro','n6NRLe0WjWVPbYtQFZ','V826YGCufyicM',
  // Naruto
  'zkA5kRmmOfoUE','4wM9zOBqDcR0s','8WpYQ9nWGp2tq',
  'Zaj8ggkt66BfoWsuUj','AGpAZmSJqIFWM','sL4S1rAFVSGWc','skVe8kyj61sqS0RlSZ',
  // Dragon Ball Z
  'wiaoWlW17fqIo','e94rZJJif4ZibPLOYj','dGV9ZF4JhTzz1SdnzK',
  '6RnbszedM7w5NduKiB','pbOg1Y7IqTyopR0Rja','gKBXWacIbPip4GVEOJ',
  '86dCvg5IxA0RM2xnav','WUhaXYKyjf5opIJrkJ','25vfsRdbfUlcp4kDDV',
];

// Fisher-Yates shuffle — different order every page load
(function shuffle(arr) {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
})(heroFightGifs);
// Specific anime show names — avoids real-life results
const heroQueries = [
  'kimetsu no yaiba tanjiro','deku my hero academia','luffy one piece',
  'eren attack on titan','naruto uzumaki fight','goku dragon ball super',
  'gojo jujutsu kaisen','ichigo bleach fight','killua hunter x hunter',
  'natsu fairy tail fight','rem rezero','levi attack on titan',
  'bakugo my hero academia','zoro one piece fight','muzan demon slayer',
];

let heroGifIndex = 0;
const heroGifEl = document.getElementById('hero-gif-img');

const HERO_GIF_OPACITY = () => document.body.classList.contains('light-mode') ? '0.32' : '0.55';
function setHeroGif() {
  heroGifIndex = (heroGifIndex + 1) % heroFightGifs.length;
  // Fetch a new batch when pool is exhausted
  if (heroGifIndex === 0) { loadHeroGifs(false); return; }
  const id = heroFightGifs[heroGifIndex];
  heroGifEl.style.opacity = '0';
  setTimeout(() => {
    heroGifEl.src = `https://media.giphy.com/media/${id}/giphy.gif`;
    heroGifEl.style.opacity = HERO_GIF_OPACITY();
  }, 200);
}

async function loadHeroGifs(startInterval = true, customQuery = null) {
  try {
    const query = customQuery || heroQueries[Math.floor(Math.random() * heroQueries.length)];
    const offset = customQuery ? 0 : Math.floor(Math.random() * 80);
    const res = await fetch(
      `https://api.giphy.com/v1/gifs/search?q=${encodeURIComponent(query)}&api_key=${GIPHY_KEY}&limit=25&offset=${offset}&rating=g&type=gifs`
    );
    const data = await res.json();
    if (data.data && data.data.length > 0) {
      heroFightGifs.length = 0;
      data.data.forEach(g => heroFightGifs.push(g.id));
      for (let i = heroFightGifs.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [heroFightGifs[i], heroFightGifs[j]] = [heroFightGifs[j], heroFightGifs[i]];
      }
      heroGifIndex = 0;
    }
  } catch(e) { /* use hardcoded fallback */ }

  heroGifEl.style.opacity = '0';
  setTimeout(() => {
    heroGifEl.src = `https://media.giphy.com/media/${heroFightGifs[heroGifIndex]}/giphy.gif`;
    heroGifEl.style.opacity = HERO_GIF_OPACITY();
  }, 200);
  if (startInterval) setInterval(setHeroGif, 4000);
}
loadHeroGifs();

const animeKeywords = [
  'anime','manga','otaku','waifu','naruto','sasuke','goku','vegeta','luffy','zoro',
  'nami','sanji','tanjiro','nezuko','zenitsu','inosuke','rengoku','deku','midoriya',
  'bakugo','todoroki','allmight','all might','eren','mikasa','levi','armin','titan',
  'gojo','itadori','megumi','nobara','sukuna','ichigo','bleach','rukia','aizen',
  'killua','gon','hisoka','kurapika','natsu','erza','fairy tail','rem','emilia',
  'beatrice','subaru','rezero','re zero','wistoria','dragon ball','dbz','attack on titan',
  'demon slayer','my hero','one piece','jujutsu','hunter x hunter','sword art','sao',
  'fullmetal','edward','alphonse','light','ryuk','death note','lelouch','code geass',
  'totoro','ghibli','spirited','howl','evangelion','cowboy bebop','trigun',
];

function isAnimeQuery(q) {
  const lower = q.toLowerCase();
  return animeKeywords.some(k => lower.includes(k));
}

function searchHeroGif() {
  const input = document.getElementById('hero-search-input');
  const query = input.value.trim();
  if (!query) return;

  // Only update GIF if the query is anime-related
  if (isAnimeQuery(query)) loadHeroGifs(false, query);

  // Set keyword chip + filter products (respects active category)
  setSearchChip(query);
  applyFilters();

  // Scroll to products
  document.getElementById('products').scrollIntoView({ behavior: 'smooth' });

  input.value = '';
}
document.getElementById('hero-search-input').addEventListener('keydown', e => {
  if (e.key === 'Enter') searchHeroGif();
});

// ── MOBILE MENU ──
function toggleMobileMenu() {
  const menu     = document.getElementById('mobile-menu');
  const backdrop = document.getElementById('mobile-backdrop');
  const burger   = document.getElementById('hamburger');
  const open     = menu.classList.toggle('open');
  backdrop.classList.toggle('open', open);
  burger.classList.toggle('open', open);
  document.body.style.overflow = open ? 'hidden' : '';
}
// Show mobile menu as flex when needed (CSS handles display via hamburger show/hide)
document.getElementById('mobile-menu').style.display = 'flex';

// Init — products first, reviews only after products render
loadProducts().then(() => loadAllReviews());

// ── SIGNUP DISCOUNT POPUP ──
function openSignup() {
  const ov = document.getElementById('signup-overlay');
  ov.classList.add('open');
  if (isSignedUp()) showSignupSuccess();
}
function closeSignup(e) {
  if (e && e.target && e.target.id !== 'signup-overlay' && !e.target.classList.contains('signup-close') && e.target.tagName !== 'BUTTON') return;
  document.getElementById('signup-overlay').classList.remove('open');
  try { sessionStorage.setItem('fannest_popup_seen', '1'); } catch(_) {}
}
function dismissFab(e) {
  if (e) e.stopPropagation();
  const fab = document.getElementById('signup-fab');
  if (fab) fab.style.display = 'none';
  // Hidden only for this view — the 10% tab always returns on the next visit/reload
}
function dismissBogoFab(e) {
  if (e) e.stopPropagation();
  const fab = document.getElementById('bogo-fab');
  if (fab) fab.style.display = 'none';
  // Hidden for this view only — the Buy 2 Get 1 Free tab returns on the next visit/reload
}
function isSignedUp() { try { return !!localStorage.getItem('fannest_signup'); } catch(_) { return false; } }
function showSignupSuccess() {
  document.getElementById('signup-form-wrap').style.display = 'none';
  document.getElementById('signup-success').style.display = 'block';
}
async function submitSignup() {
  const input = document.getElementById('signup-email');
  const err = document.getElementById('signup-error');
  const email = (input.value || '').trim();
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.textContent = 'Please enter a valid email.'; return; }
  err.textContent = '';
  try { localStorage.setItem('fannest_signup', email); } catch(_) {}
  // best-effort store to Supabase (ignored if table/policy missing)
  try { if (typeof sb !== 'undefined') sb.from('signups').insert({ email, code: 'FANNEST10' }); } catch(_) {}
  showSignupSuccess();
  const fb = document.getElementById('signup-fab-btn'); if (fb) fb.textContent = '🎁 Your 10% code';
}
// auto-open once per session for new visitors
(function () {
  let seen = false; try { seen = sessionStorage.getItem('fannest_popup_seen'); } catch(_) {}
  if (!seen && !isSignedUp()) setTimeout(() => { if (!document.getElementById('signup-overlay').classList.contains('open')) openSignup(); }, 6000);
  if (isSignedUp()) { const fb = document.getElementById('signup-fab-btn'); if (fb) fb.textContent = '🎁 Your 10% code'; }
  // The 10% tab stays pinned bottom-left on EVERY visit (no persisted dismissal)
})();

// Turn a 2-letter ISO country code (e.g. "AU") into its flag emoji 🇦🇺
function countryToFlag(cc) {
  if (!cc || cc.length !== 2) return '';
  try { return cc.toUpperCase().replace(/./g, c => String.fromCodePoint(127397 + c.charCodeAt(0))); }
  catch (e) { return ''; }
}

// ── ALL-IN-ONE COMMUNITY REVIEWS ──
async function loadAllReviews() {
  const grid = document.getElementById('reviews-all-grid');
  const sub  = document.getElementById('reviews-all-sub');
  if (!grid || typeof sb === 'undefined') return;
  try {
    const { data: reviews } = await sb.from('reviews').select('*').order('created_at', { ascending: false });
    if (!reviews || reviews.length === 0) {
      grid.innerHTML = '<div class="reviews-all-empty">No reviews yet — be the first to share the love 💙<br><br><button class="btn-primary" onclick="scrollToProducts()">Shop & Review</button></div>';
      return;
    }
    const avg = (reviews.reduce((s,r)=>s+(r.rating||0),0)/reviews.length).toFixed(1);
    if (sub) sub.textContent = `${avg}★ average from ${reviews.length}+ happy anime fans 💙`;

    const INITIAL = 6;
    const BATCH   = 10;
    let shown = INITIAL;

    function renderReviews() {
      grid.innerHTML = reviews.slice(0, shown).map(r => `
        <div class="rev-card">
          <div class="rev-card-top">
            <span class="rev-card-user">👤 ${(r.username || 'Anonymous')}${r.country ? ' ' + countryToFlag(r.country) : ''}</span>
            <span class="rev-card-stars">${'★'.repeat(r.rating||5)}${'☆'.repeat(5-(r.rating||5))}</span>
          </div>
          <div class="rev-card-text">"${(r.comment || '').replace(/</g,'&lt;')}"</div>
          ${r.photo_url ? `<img class="rev-card-photo" src="${r.photo_url}" alt="Customer photo" loading="lazy" onclick="window.open('${r.photo_url}','_blank')">` : ''}
          <div class="rev-card-foot">
            <span class="rev-card-badge">✓ Verified buyer</span>
            <span>${r.created_at ? new Date(r.created_at).toLocaleDateString() : ''}</span>
          </div>
        </div>
      `).join('');

      let ctrl = document.getElementById('reviews-all-controls');
      if (!ctrl) {
        ctrl = document.createElement('div');
        ctrl.id = 'reviews-all-controls';
        ctrl.className = 'reviews-all-controls';
        grid.insertAdjacentElement('afterend', ctrl);
      }
      ctrl.innerHTML = '';
      if (shown < reviews.length) {
        const btn = document.createElement('button');
        btn.className = 'btn-reviews-more';
        btn.textContent = `Show ${Math.min(BATCH, reviews.length - shown)} more reviews ↓`;
        btn.onclick = () => { shown = Math.min(shown + BATCH, reviews.length); renderReviews(); };
        ctrl.appendChild(btn);
      }
      if (shown > INITIAL) {
        const btn = document.createElement('button');
        btn.className = 'btn-reviews-less';
        btn.textContent = 'Show less ↑';
        btn.onclick = () => {
          shown = INITIAL;
          renderReviews();
          document.getElementById('reviews-all')?.scrollIntoView({ behavior: 'smooth' });
        };
        ctrl.appendChild(btn);
      }
    }

    renderReviews();
  } catch(e) {
    grid.innerHTML = '<div class="reviews-all-empty">Reviews are loading slowly — please refresh.</div>';
  }
}

// ── AUTO PROMO HEADLINE (matches the automatic discounts set in Shopify) ──
// Buyers never type a code — the discount applies automatically at checkout.
// This bar just announces whatever sale is live today.
const PROMO_EVENTS = [
  { start: '2026-06-24', end: '2026-07-13', pct: 0.15, text: '☀️ SUMMER SPLASH — 15% OFF everything, applied automatically at checkout! 🌊' },
  { start: '2026-08-20', end: '2026-09-05', pct: 0.15, text: '🎒 BACK TO SCHOOL — 15% OFF all anime merch, no code needed!' },
  { start: '2026-10-24', end: '2026-11-01', pct: 0.20, text: '🎃 SPOOKY SEASON — 20% OFF everything, auto-applied! 👻' },
  { start: '2026-11-09', end: '2026-11-12', pct: 0.20, text: "🛍️ SINGLES' DAY 11.11 — 20% OFF sitewide, automatically!" },
  { start: '2026-11-26', end: '2026-12-01', pct: 0.25, text: '🖤 BLACK FRIDAY — 25% OFF everything, auto-applied at checkout! 🔥' },
  { start: '2026-12-12', end: '2026-12-26', bogo: true, text: '🎄 CHRISTMAS — Buy 2 Get 1 FREE, added automatically! 🎁' },
  { start: '2026-12-30', end: '2027-01-04', pct: 0.20, text: '🎆 NEW YEAR SALE — 20% OFF to start the year, no code needed!' },
  { start: '2027-02-07', end: '2027-02-14', pct: 0.15, text: "💝 VALENTINE'S — 15% OFF for you & your waifu, auto-applied!" },
];
function activeEventNow() {
  const today = new Date(); today.setHours(0,0,0,0);
  return PROMO_EVENTS.find(ev => {
    const s = new Date(ev.start + 'T00:00:00'); const e = new Date(ev.end + 'T23:59:59');
    return today >= s && today <= e;
  }) || null;
}
// Always-on offer that powers the cart progress bar
const BOGO_BUY = 2, BOGO_GROUP = 3; // buy 2, get the 3rd free
(function initPromoBar() {
  const bar = document.getElementById('promo-bar');
  const txt = document.getElementById('promo-bar-text');
  const cd  = document.getElementById('promo-bar-countdown');
  if (!bar || !txt) return;
  try { if (sessionStorage.getItem('fannest_promo_closed')) return; } catch(e) {}
  const today = new Date(); today.setHours(0,0,0,0);
  const active = PROMO_EVENTS.find(ev => {
    const s = new Date(ev.start + 'T00:00:00'); const e = new Date(ev.end + 'T23:59:59');
    return today >= s && today <= e;
  });
  const fallback = window.PROMO_TEXT_FALLBACK;
  txt.innerHTML = active ? active.text : (fallback && fallback.trim() ? fallback : '💙 Hand-picked anime merch · Ships to 30+ countries · Prices in your currency');
  bar.style.display = 'block';
  // Live countdown to the end of the active sale
  if (active && cd) {
    const endTime = new Date(active.end + 'T23:59:59').getTime();
    const tick = () => {
      const diff = endTime - Date.now();
      if (diff <= 0) { cd.style.display = 'none'; return; }
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      const pad = n => String(n).padStart(2, '0');
      cd.textContent = '⏳ ' + (d > 0 ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's left';
      cd.style.display = 'inline-block';
    };
    tick();
    setInterval(tick, 1000);
  }
})();

// ── 3D PRODUCT SHOWCASE ──
(function() {
  const showcase  = document.getElementById('product-showcase');
  const card      = document.getElementById('product-card-3d');
  const cardImg   = document.getElementById('card-img');
  const cardLabel = document.getElementById('card-label');
  const dotsEl    = document.getElementById('card-dots');
  if (!showcase) return;

  let products = [];
  let current  = 0;
  let targetRX = 0, targetRY = 0, currentRX = 0, currentRY = 0;
  let autoTimer = null;

  // Fetch real products from Shopify
  fetch('https://anime-lovers-9830.myshopify.com/products.json?limit=8&country=AU')
    .then(r => r.json())
    .then(data => {
      products = (data.products || []).filter(p => p.images && p.images.length > 0).slice(0, 6);
      if (!products.length) return;
      buildDots();
      showProduct(0);
      startAuto();
    })
    .catch(() => {});

  function buildDots() {
    dotsEl.innerHTML = '';
    products.forEach((_, i) => {
      const d = document.createElement('div');
      d.className = 'card-dot' + (i === 0 ? ' active' : '');
      d.addEventListener('click', () => { showProduct(i); resetAuto(); });
      dotsEl.appendChild(d);
    });
  }

  function showProduct(i) {
    current = i;
    const p = products[i];
    cardImg.style.opacity = '0';
    cardImg.style.transform = 'scale(0.92)';
    setTimeout(() => {
      cardImg.src = p.images[0].src;
      cardImg.alt = p.title;
      cardLabel.textContent = p.title;
      cardImg.style.opacity = '1';
      cardImg.style.transform = 'scale(1)';
    }, 180);
    dotsEl.querySelectorAll('.card-dot').forEach((d, j) => d.classList.toggle('active', j === i));
    showcase.dataset.handle = p.handle;
  }

  showcase.addEventListener('click', () => {
    const p = products[current];
    if (!p) return;
    // Find the matching product card in the grid by handle
    const card = document.querySelector(`.product-card[data-handle="${p.handle}"]`);
    if (card) {
      card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      card.style.transition = 'box-shadow 0.3s';
      card.style.boxShadow = '0 0 0 3px #38b6ff, 0 0 32px rgba(56,182,255,0.5)';
      setTimeout(() => { card.style.boxShadow = ''; }, 2000);
    } else {
      document.getElementById('products').scrollIntoView({ behavior: 'smooth' });
    }
  });

  function startAuto() {
    autoTimer = setInterval(() => showProduct((current + 1) % products.length), 3200);
  }
  function resetAuto() {
    clearInterval(autoTimer);
    startAuto();
  }

  // CSS transition for image swap
  cardImg.style.transition = 'opacity 0.18s ease, transform 0.18s ease';

  // Mouse parallax tilt
  const hero = document.querySelector('.hero');
  hero.addEventListener('mousemove', e => {
    const rect = showcase.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top  + rect.height / 2;
    const dx = (e.clientX - cx) / (window.innerWidth  * 0.5);
    const dy = (e.clientY - cy) / (window.innerHeight * 0.5);
    targetRY =  dx * 22;
    targetRX = -dy * 16;
  });
  hero.addEventListener('mouseleave', () => { targetRX = 0; targetRY = 0; });

  // Smooth interpolation loop
  (function loop() {
    requestAnimationFrame(loop);
    currentRX += (targetRX - currentRX) * 0.1;
    currentRY += (targetRY - currentRY) * 0.1;
    card.style.transform = `rotateX(${currentRX}deg) rotateY(${currentRY}deg)`;
  })();
})();
